import React, { FC } from 'react';
import { ICircle } from 'src/@settings/interfaces';

export const Circle: FC<ICircle> = ({ circleType }) => {
  return <div className={circleType} />;
};
